module.exports = __webpack_public_path__ + "static/orange-wave-xs-3242d1f884d998531c60542a290cf9d0.png";